
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registrace",
      function () {
        return require("private-next-pages/registrace/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registrace"])
      });
    }
  